<template>
  <div class="companySolution">
    <div class="banner"></div>
    <div class="w companySolutionBox">
      <div class="dataShow_rank">
        <div class="dataShow_rankTitle">推荐商家</div>
        <rankList></rankList>
      </div>
      <div class="companySolutionInfo">
          <el-image
          class="companySolutionInfo_Img"
          :src="companySolutionImg"
          fit="cover"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import rankList from "@/components/RemoteSensingMall/rankList.vue";

export default {
  components: {
    rankList,
  },
  data() {
    return {
      activeName: "1",
      companySolutionImg: require("@/assets/imgs/RemoteSensingMall/companySolutionImg.png"),
    };
  },
  mounted() {},
  methods: {
    tabClick(e) {
      this.activeName = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.companySolutionInfo_Img{
  width: 100%;
}
.companySolutionInfo{
  padding: 10px;width: 75%;
}
.companySolutionBox {
  display: flex;
}
.dataShow_rankTitle {
  font-size: 18px;
  margin-bottom: 10px;
}
.dataShow_rank {
  width: 25%;
  padding: 20px;
  background: #f5f7fa;
}
.banner {
  position: relative;
  width: 100%;
  margin: 0;
  height: 430px;
  background-image: url("../../assets/imgs/RemoteSensingMall/companySolution.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>